import React from 'react';

export default function ResumoDia({
  frotaList = [],
  contratosList = [],
  financeiroList = [],
  manutencoesList = [],
  abastecimentosList = []
}) {
  const hoje = new Date().toISOString().split('T')[0];

  const contratosHoje = contratosList.filter(c => (c?.data || '') === hoje);

  const entreguesHoje = contratosList.filter(c => {
    const confirmado = String(c?.entrega_confirmada_em || '');
    return confirmado.startsWith(hoje) || (c?.status_entrega === 'Entregue' && c?.data === hoje);
  });

  const financeiroHoje = financeiroList.filter(f => (f?.vencimento || '') === hoje);

  const receitasHoje = financeiroHoje
    .filter(f => f?.tipo === 'Receita')
    .reduce((acc, item) => acc + (Number(item?.valor) || 0), 0);

  const despesasHoje = financeiroHoje
    .filter(f => f?.tipo === 'Despesa')
    .reduce((acc, item) => acc + (Number(item?.valor) || 0), 0);

  const saldoHoje = receitasHoje - despesasHoje;

  const manutencoesHoje = manutencoesList.filter(m => (m?.data || '') === hoje);
  const abastecimentosHoje = abastecimentosList.filter(a => {
    // abastecimento legado não possui data própria; a despesa financeira é a referência do dia
    return financeiroHoje.some(f => f?.id === `abas-${a?.id}`);
  });

  const emViagem = frotaList.filter(f => f?.status === 'Em Viagem').length;
  const disponiveis = frotaList.filter(f => f?.status === 'Disponível').length;
  const emManutencao = frotaList.filter(f => f?.status === 'Manutenção').length;

  const moeda = (valor) =>
    Number(valor || 0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });

  const card = {
    backgroundColor: '#141414',
    border: '1px solid #222',
    padding: '18px',
    borderRadius: '8px'
  };

  return (
    <div style={{ width: '100%', boxSizing: 'border-box' }}>
      <div style={{ marginBottom: '24px' }}>
        <span style={{ fontSize: '11px', textTransform: 'uppercase', color: '#777', letterSpacing: '1.5px', fontWeight: 'bold' }}>
          Resumo do Dia · {new Date().toLocaleDateString('pt-BR')}
        </span>
        <h2 style={{ fontSize: '24px', fontWeight: '800', margin: '4px 0 0 0' }}>
          Fechamento Operacional
        </h2>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: '14px', marginBottom: '22px' }}>
        <div style={card}><span style={{ color: '#888', fontSize: '11px' }}>SALDO DO DIA</span><p style={{ fontSize: '22px', fontWeight: '800', color: saldoHoje >= 0 ? '#32D74B' : '#FF3B30' }}>{moeda(saldoHoje)}</p></div>
        <div style={card}><span style={{ color: '#888', fontSize: '11px' }}>RECEITAS DO DIA</span><p style={{ fontSize: '22px', fontWeight: '800', color: '#32D74B' }}>{moeda(receitasHoje)}</p></div>
        <div style={card}><span style={{ color: '#888', fontSize: '11px' }}>DESPESAS DO DIA</span><p style={{ fontSize: '22px', fontWeight: '800', color: '#FF3B30' }}>{moeda(despesasHoje)}</p></div>
        <div style={card}><span style={{ color: '#888', fontSize: '11px' }}>CONTRATOS HOJE</span><p style={{ fontSize: '22px', fontWeight: '800', color: '#FFD60A' }}>{contratosHoje.length}</p></div>
        <div style={card}><span style={{ color: '#888', fontSize: '11px' }}>ENTREGAS CONCLUÍDAS</span><p style={{ fontSize: '22px', fontWeight: '800', color: '#32D74B' }}>{entreguesHoje.length}</p></div>
        <div style={card}><span style={{ color: '#888', fontSize: '11px' }}>EM VIAGEM</span><p style={{ fontSize: '22px', fontWeight: '800', color: '#007AFF' }}>{emViagem}</p></div>
        <div style={card}><span style={{ color: '#888', fontSize: '11px' }}>DISPONÍVEIS</span><p style={{ fontSize: '22px', fontWeight: '800', color: '#32D74B' }}>{disponiveis}</p></div>
        <div style={card}><span style={{ color: '#888', fontSize: '11px' }}>MANUTENÇÃO</span><p style={{ fontSize: '22px', fontWeight: '800', color: '#FFD60A' }}>{emManutencao}</p></div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '18px' }}>
        <div style={{ ...card, padding: '22px' }}>
          <h3 style={{ fontSize: '12px', textTransform: 'uppercase', color: '#888', marginBottom: '14px' }}>Operações do dia</h3>
          {contratosHoje.length === 0 ? (
            <p style={{ color: '#666', fontSize: '13px' }}>Nenhum contrato criado para hoje.</p>
          ) : contratosHoje.map(c => (
            <p key={c.id} style={{ fontSize: '13px', color: '#ccc', lineHeight: 1.6 }}>
              • {c.cliente}: {c.origem} → {c.destino} · <b>{c.status_entrega || c.status}</b>
            </p>
          ))}
        </div>

        <div style={{ ...card, padding: '22px' }}>
          <h3 style={{ fontSize: '12px', textTransform: 'uppercase', color: '#888', marginBottom: '14px' }}>Custos e ocorrências</h3>
          <p style={{ fontSize: '13px', color: '#ccc' }}>Manutenções registradas hoje: <b>{manutencoesHoje.length}</b></p>
          <p style={{ fontSize: '13px', color: '#ccc' }}>Abastecimentos com despesa hoje: <b>{abastecimentosHoje.length}</b></p>
          <p style={{ fontSize: '13px', color: '#ccc' }}>Lançamentos financeiros hoje: <b>{financeiroHoje.length}</b></p>
        </div>
      </div>
    </div>
  );
}
